//export const SERVER_HOSTNAME = "https://eduavatar.leadingbuddy.com";
//export const SERVER_HOSTNAME = 'https://toontales.leadingbuddy.com'
//export const SERVER_HOSTNAME = 'http://localhost:3003'
//export const SERVER_HOSTNAME = 'https://toontales.leadingbuddy.com'
export const SERVER_HOSTNAME = 'https://toontales.enterglider.com'
export const RAZORYPAY_TEST_KEY_ID = 'rzp_test_XjsNtJxLdNYynu'
export const RAZORYPAY_KEY_ID = 'rzp_live_16dToXrg7MUtRx'
export const EXPO_PROJECT_ID = '1bc36c5c-b281-491e-8260-e148b65697d7'
